import searchNumbers from './searchNumbers';
import { getArguments } from './findPhoneNumbersInText';
export default function searchPhoneNumbersInText(text, defaultCountry, options, metadata) {
  var args = getArguments(defaultCountry, options, metadata);
  return searchNumbers(text, args.options, args.metadata);
}
//# sourceMappingURL=searchPhoneNumbersInText.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/es6/searchPhoneNumbersInText.js
// module id = 582
// module chunks = 0 7 8 9 10